import { Injectable } from '@angular/core';

@Injectable()
export abstract class IconInfoPopup {
    abstract OpenIconInfoPopup(isIconInfoOpen): void;
}